import { render } from "./CoinUp.vue?vue&type=template&id=989fc690"
import script from "./CoinUp.vue?vue&type=script&lang=js"
export * from "./CoinUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__